import { useTranslation } from 'react-i18next'

// Matches the prototype's `addFilterErasers()` — every filter field across
// Usage/Limits gets a small accent "eraser" icon inline with its caption
// that resets just that field to its unfiltered state (see
// usage-billing.html). Not a generic close/clear icon: the prototype draws
// a literal eraser (a rotated rounded rect with one edge line) rather than
// an X, so this copies that exact shape rather than reusing a generic icon.
export function FilterLabel({
  label,
  onClear,
}: Readonly<{ label: string; onClear?: () => void }>) {
  const { t } = useTranslation()
  return (
    <div className="flex items-center justify-between gap-1.5">
      <label className="text-[10.5px] font-semibold uppercase tracking-[.4px] text-[var(--text-tertiary)]">
        {label}
      </label>
      {onClear && (
        <button
          type="button"
          onClick={onClear}
          title={t('common.clearFilter')}
          aria-label={t('common.clearFilter')}
          className="text-[var(--text-tertiary)] hover:bg-[rgba(128,128,128,0.14)] p-0.5 rounded-[5px] flex items-center justify-center"
        >
          <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <g transform="rotate(-45 12 12)">
              <rect x="3" y="7" width="18" height="10" rx="2" />
              <line x1="7" y1="7" x2="7" y2="17" />
            </g>
          </svg>
        </button>
      )}
    </div>
  )
}
